import { useGetContractPackageInfo } from '../../../hooks/event-store-hooks';
import ContractIcon from '../../../components/contract-icon/contract-icon';
import { BodyText } from '@make-software/cspr-design';
import { HistoryLink } from '../../../components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TooltipWithExtendedInfo from '../../tooltip-with-extended-info/tooltip-with-extended-info';

export const NftCollectionIdentifier = ({
  collectionHash,
  getContractPackagePath,
}: {
  collectionHash: string;
  getContractPackagePath: (hash: string) => string;
}) => {
  const { t } = useTranslation();
  const { data: collectionInfo } = useGetContractPackageInfo({
    contract_package_hash: collectionHash,
  });

  const info = collectionInfo?.data;

  return info ? (
    <>
      <ContractIcon
        size={'small'}
        contractTypeId={info?.latest_version_contract_type_id}
        src={info.icon_url}
      />
      <TooltipWithExtendedInfo
        hash={info.contract_package_hash}
        tooltipCaption={t('Contract Package Hash')}
        extendedLine={{
          title: info.name,
          caption: t('Contract name'),
        }}
      >
        <BodyText size={3} variation={'black'} monotype>
          <HistoryLink
            href={getContractPackagePath(info.contract_package_hash)}
            ariaDescription={'Link to contract package details'}
          >
            {info.name}
          </HistoryLink>
        </BodyText>
      </TooltipWithExtendedInfo>
      <BodyText size={3} variation={'darkGray'}>
        NFT(s)
      </BodyText>
    </>
  ) : null;
};
